module.exports = __webpack_public_path__ + "img/SL-M-220-270.1c3f02bc.svg";